
import { ApiContext } from "../ApiContext";

export class ApiPayerReceiversReport extends ApiContext {
    public async queue(params: Partial<ApiPayerReceiversReport.ReportProps>) {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
        };
        return this.client.http
            .post(`/queue/report/payer-receivers`, params, config)
            .then((res) => res.data);
    }

}
export namespace ApiPayerReceiversReport {
    export interface ReportProps {
        list_document: any[],
        to: string,
    }
}
